import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawaySessionHistory = async (id) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/briefs/giveaways/${id}/sessions` });

  return data?.data;
};

export default getGiveawaySessionHistory;
